import { OrderDataFusionSummary } from "../../../dispatch/src/OrderDataFusionSummary";
import { StopProgress } from "../../../dispatch/src/StopProgress";
import { DataSource, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiBillingOverview extends Layout {
    billingDistanceDangerImage: Image;
    imageComments: Image;
    imageInboundDFInvoiceError: Image;
    imageInboundWarning: Image;
    imageNotifications: Image;
    imageOutboundDFInvoiceError: Image;
    imageOutboundDFInvoiceWarning: Image;
    imageRebill: Image;
    imageSplitBill: Image;
    label4: Label;
    labelBillDistanceUm: Label;
    labelBillingDistance: Label;
    labelBillingDistanceCaption: Label;
    labelBridgeCustomer: Label;
    labelCreateDate: Label;
    labelCreateDtCaption: Label;
    labelDirection: Label;
    labelDirectionCaption: Label;
    labelEquipmentTypeId: Label;
    labelGSDateCaption: Label;
    labelGsDateTime: Label;
    labelO: Label;
    labelOrdersorderValue: Label;
    labelPartnerName: Label;
    labelPartnerNameID: Label;
    labelReferenceNumbers: Label;
    labelTempDelim: Label;
    labelTempMax: Label;
    labelTempMin: Label;
    labelTemperatureRange: Label;
    labelTotalChargeswithTaxes: Label;
    labelTrackingRequired: Label;
    labelTrailerType: Label;
    layoutOrderDataFusionSummary: OrderDataFusionSummary;
    layoutStopProgress: StopProgress;
    panel15: Panel;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel8: Panel;
    panelBillingDistance: Panel;
    panelCommodity: Panel;
    panelDataFusion: Panel;
    panelDelivered: Panel;
    panelIcons: Panel;
    panelLeft: Panel;
    panelOrderInfo: Panel;
    panelStopInfo: Panel;
    panelTax: Panel;
    panelTaxInfo: Panel;
    panelTempRange: Panel;
    sourceBillingComments: DataSource;
    sourceCalculateOverridePay: DataSource;
    sourceCustomer: DataSource;
    sourceDataFusionOrderSummary: DataSource;
    sourceDistanceAlert: DataSource;
    sourceEdiBillingDetails: DataSource;
    sourceEdiMapError: DataSource;
    textboxBillingDate: Textbox;
    textboxBillingUser: Textbox;
    textboxBlnum: Textbox;
    textboxBolDate: Textbox;
    textboxCommodity: Textbox;
    textboxConsigneeRefNo: Textbox;
    textboxContactName: Textbox;
    textboxExcisetaxTotal: Textbox;
    textboxFreightCharge: Textbox;
    textboxInvoiceNbr: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxName: Textbox;
    textboxOtherCharge: Textbox;
    textboxPieces: Textbox;
    textboxShipmentId: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalchargeAndExcisetax: Textbox;
    textboxTransferDate: Textbox;
    textboxWeight: Textbox;
}
